/*
 * @Author: echo
 * @Date: 2024-10-08 17:57:17
 * 导航栏 ai弹窗
 */
 <template>
  <v-dialog v-model="chatBoxData.dialog"
            width="600">
    <v-card class="blue-title">
      <div>
        <iframe src="https://gpts.acadsoc.com/chat/1CpFPGkhERJYzyuE" style="border-radius:10px!important;width: 100%; height: 100%; min-height: 700px" frameborder="0" allow="microphone"></iframe>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'level',
  props: {
    chatBoxData: {
      dialog: false
    }
  },
  data: () => ({
   
  }),
  mounted () {
  },
  methods: {
    show () {
      this.chatBoxData.dialog = true
    }
  }
}
</script>
